import styled, { css } from 'styled-components';
import { IconHourglass } from '@tabler/icons-react';

export const StyledHourglassIcon = styled(IconHourglass)`
    ${({ theme }) => css`
        & {
            color: ${theme.colors.primary.primary8};
        }
    `}
`;
